import { useWorkspace } from '@/contexts/WorkspaceContext';

export function useManagedWorkspace() {
  const { workspaces, currentWorkspace } = useWorkspace();

  const isCurrentManageable = currentWorkspace && 
    (currentWorkspace.type === 'admin' || currentWorkspace.type === 'team') && 
    ['owner', 'admin', 'admin-viewer'].includes(currentWorkspace.role);

  const managedWorkspace = isCurrentManageable 
    ? currentWorkspace 
    : workspaces.find(w => 
        (w.type === 'admin' || w.type === 'team') && 
        ['owner', 'admin', 'admin-viewer'].includes(w.role)
      );

  return { managedWorkspace, isCurrentManageable };
}
